import axios from "axios";

const API = "https://backapi.ypsispma.com/api/admin";

export const createUser = (data) => axios.post(`${API}/users`, data);
export const getUsers = () => axios.get(`${API}/users`);
export const getRoles = () => axios.get(`${API}/roles`);
export const getPermissions = () => axios.get(`${API}/permissions`);

export const getUserRoles = (userID) =>  axios.get(`${API}/users/${userID}/roles`);

export const getAllRoles = () =>  axios.get(`${API}/roles/all`);

export const assignRole = (data) =>  axios.post(`${API}/users/assign-role`, data);